import { all, put, call, takeLatest } from 'redux-saga/effects'
import axios from 'portal/utils/axios-msal'

import type { APITypes } from '@qflow/api'

import {
  carriersLoadSuccess,
  carriersLoadFailure,
  CARRIERS_LOAD,
  CARRIERS_LOAD_CONTINUATION,
  carriersLoadAction,
  carriersLoadContinuationAction
} from './actions'

function* carriersLoadSaga(action: carriersLoadAction) {
  try {
    let carriers: APITypes.WasteCarrier[] = []

    const params: any = {
      'page[size]': 100
    }

    if (action.hint != null && action.hint.length > 0) {
      params['hint'] = action.hint
    }

    const response: { data: PagedResponse } = yield call(() =>
      axios.get(`/referencedata/waste/carriers`, {
        params: params
      })
    )

    carriers = response && response.data ? [...response.data.items] : []

    yield put(
      carriersLoadSuccess(
        carriers,
        response.data.continuationToken,
        response.data.hasNextPage
      )
    )
  } catch (error) {
    console.error(error)
    yield put(carriersLoadFailure(error))
  }
}

function* carriersLoadContinuationSaga(action: carriersLoadContinuationAction) {
  try {
    let carriers: APITypes.WasteCarrier[] = []

    const params: any = {
      'page[size]': 100
    }

    if (action.hint != null && action.hint.length > 0) {
      params['hint'] = action.hint
    }

    const response: { data: PagedResponse } = yield call(() =>
      axios.get(`/referencedata/waste/carriers`, {
        params: params,
        headers: { contToken: action.continuationToken }
      })
    )

    carriers = response && response.data ? [...response.data.items] : []

    yield put(
      carriersLoadSuccess(
        carriers,
        response.data.continuationToken,
        response.data.hasNextPage
      )
    )
  } catch (error) {
    console.error(error)
    yield put(carriersLoadFailure(error))
  }
}

export function* watch() {
  yield all([
    takeLatest(CARRIERS_LOAD, carriersLoadSaga),
    takeLatest(CARRIERS_LOAD_CONTINUATION, carriersLoadContinuationSaga)
  ])
}

export interface PagedResponse {
  continuationToken: string
  hasNextPage: boolean
  items: APITypes.WasteCarrier[]
}
